import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import { ICON_PLACEMENTS, DESCRIPTION_PLACEMENTS, SIZES } from './constants';
import Icon from '../icon';
import { TYPES } from '../icon/constants';
import BetaLabel from '../beta-label';
import Flag from '../flag';
import Paragraph from '../paragraph';
import { APPEARANCES } from '../text/constants';
import Title from './title';

const BaseActionListItem = ({
  component: Component = Title,
  title,
  description = '',
  size = SIZES.small,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  flagCode = null,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'IconGlyph'.
  iconGlyph = null,
  disabled = false,
  selected = false,
  onClick = Function.prototype,
  noninteractive = false,
  descriptionPlacement = DESCRIPTION_PLACEMENTS.bottom,
  iconPlacement = ICON_PLACEMENTS.right,
  iconType = TYPES.inherit,
  withBetaLabel = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'React.ReactElement | string'.
  contentRight = null,
  ...otherProps
}) => {
  const isMobile = bowser.mobile;
  const iconColor = disabled ? TYPES.inherit : iconType;
  const iconSize = isMobile ? 24 : 20;
  const isContainerReversed = iconPlacement === ICON_PLACEMENTS.left;
  const showContentRight = !isContainerReversed && !flagCode && contentRight;
  const showIcon =
    (!flagCode && !contentRight && iconGlyph) || (isContainerReversed && !flagCode && iconGlyph);
  const showBetaLabel =
    (!contentRight && !iconGlyph && withBetaLabel) || (isContainerReversed && withBetaLabel);

  const classes = classNames('ws-ui-action-list-item', `ws-ui-action-list-item--${size}`, {
    'ws-ui-action-list-item--disabled': disabled,
    'ws-ui-action-list-item--selected': selected,
    'ws-ui-action-list-item--mobile': isMobile,
    'ws-ui-action-list-item--noninteractive': noninteractive,
  });

  const containerClasses = classNames('ws-ui-action-list-item__container', {
    'ws-ui-action-list-item__container--with-flag': flagCode,
    'ws-ui-action-list-item__container--reverse': isContainerReversed && !flagCode,
    'ws-ui-action-list-item__container--with-icon': showIcon,
    'ws-ui-action-list-item__container--with-right-content': showContentRight,
    'ws-ui-action-list-item__container--with-beta-label': showBetaLabel,
  });

  const contentClasses = classNames('ws-ui-action-list-item__content', {
    'ws-ui-action-list-item__content--row': descriptionPlacement === DESCRIPTION_PLACEMENTS.right,
  });

  return (
    <div className={classes} onClick={onClick} {...otherProps}>
      <div className={containerClasses}>
        {flagCode && (
          <div className="ws-ui-action-list-item__flag">
            <Flag code={flagCode} size={iconSize} />
          </div>
        )}

        <div className={contentClasses}>
          <Component>{title}</Component>
          {description && (
            <Paragraph appearance={APPEARANCES.mediumEmphasis} isClipped>
              {description}
            </Paragraph>
          )}
        </div>

        {showContentRight && (
          <div className="ws-ui-action-list-item__content-right">{contentRight}</div>
        )}

        {showBetaLabel && (
          <div className="ws-ui-action-list-item__beta-label">
            <BetaLabel />
          </div>
        )}

        {showIcon && (
          <div className="ws-ui-action-list-item__icon">
            <Icon glyph={iconGlyph} type={iconColor} size={iconSize} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BaseActionListItem;
